module.exports = "<h2 id=this-exhibition-has-now-closed-thank-you-to-all-that-visited->This exhibition has now closed. Thank you to all that visited!</h2> ";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/markdown/pages/tickets_1.md
// module id = 220
// module chunks = 0